import { useLocation } from "react-router-dom";

const useCurrentPath = () => {
  return useLocation().pathname;
};

export default useCurrentPath;
